<div class="container-fluid p-0">
  <router-outlet></router-outlet>
</div>
